import React, { ReactNode } from "react";

import Divider from "veneer/Divider";
import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import { toString } from "cortex/ui/src/redux-store/users/selectors";
import { Collapsible } from "cortex/ui/src/ui/collapsible";
import { formatDateTime } from "cortex/ui/src/ui/table/formats";
import { User } from "cortex/ui/src/user/model";
import { Incident } from "cortex/ui/src/zeus/view/incidents/model";

export const formatResolveDetails = (
  users: Record<string, User>,
  row: Incident,
): ReactNode => {
  const {
    comment,
    resolved,
    resolve_date: resolveDate,
    user_id: resolvedByUser,
  } = row;

  if (!resolved) {
    return null;
  }

  const user =
    resolvedByUser != null ? users[String(resolvedByUser)] : undefined;
  const resolvedByElem = toString(user);

  return (
    <Stack direction="column" spacing={0.5}>
      <Typography variant="body2">
        Resolved by {resolvedByElem || "unknown"} on
        {" " + formatDateTime(resolveDate ?? "")}
      </Typography>
      {comment && (
        <>
          <Divider />
          <Typography color={Colors.gray500} variant="caption">
            {comment}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export const formatNotified = (
  users: Record<string, User>,
  row: Incident,
): ReactNode => {
  const notified = row.notified ?? [];
  const usersNotified = notified
    .map((userId: number, i: number) => {
      const user = users[String(userId)];

      return user ? (
        <div className="user list-content" key={i}>
          {toString(user)}
        </div>
      ) : null;
    })
    .filter((elem: ReactNode) => elem);

  const usersLen = usersNotified.length;

  if (usersLen === 1) {
    return usersNotified[0];
  }

  return <Collapsible label={`${usersLen} Users`}>{usersNotified}</Collapsible>;
};
